import styles from "./ResetStage.module.css";
import SubmitButton from "../../../../../components/Button/SubmitButton/SubmitButton";
import PasswordInput from "../../../../../components/Input/PasswordInput/PasswordInput";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BACKEND_URL } from "../../../../../services/authService";
interface ResetStageProps {
    onBack?: () => void;
}

const ResetStage = ({ onBack }: ResetStageProps) => {
    const { t } = useTranslation();
    const nav = useNavigate();
    const [searchParams] = useSearchParams();
    const otp = searchParams.get("otp") || "";

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!otp) {
            alert(t("forgot_password.invalid_or_expired_link") || "Neplatný/expirovaný odkaz.");
            return;
        }
        if (!password || password.length < 8) {
            alert(t("forgot_password.password_short") || "Heslo musí mít alespoň 8 znaků.");
            return;
        }
        if (password !== confirmPassword) {
            alert(t("forgot_password.password_mismatch") || "Hesla se neshodují.");
            return;
        }

        try {
            setSubmitting(true);
            const res = await fetch(
                `${BACKEND_URL}/eshop/auth/reset/confirm`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ otp, password }),
                }
            );

            if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                throw new Error(err?.error || "Reset confirm failed");
            }

            nav("/login");
        } catch (err: any) {
            alert(err.message || t("forgot_password.fail_msg") || "Nepodařilo se změnit heslo.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className={styles.FormBlock}>
            <div className={styles.FormSubtitle}>
                <p>{t("forgot_password.create")}</p>
            </div>

            <form className={styles.Form} onSubmit={onSubmit}>
                <div className={styles.InputCapsule}>
                    <PasswordInput
                        text={t("forgot_password.text")}
                        password={password}
                        onChange={setPassword}
                    />
                    <PasswordInput
                        text={t("forgot_password.text_again")}
                        password={confirmPassword}
                        onChange={setConfirmPassword}
                    />
                </div>
                <SubmitButton disabled={submitting} text={t("forgot_password.submit")} />
            </form>
        </div>
    );
};

export default ResetStage;


/*
Oldversion


import styles from "./ResetStage.module.css"
import SubmitButton from "../../../../../components/Button/SubmitButton/SubmitButton";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import PasswordInput from "../../../../../components/Input/PasswordInput/PasswordInput";
interface ResetStageProps {
    onBack?: () => void;
}

const ResetStage = ({ onBack }: ResetStageProps) => {
    const { t } = useTranslation(); // Translation
    const nav = useNavigate() // Navigate

    // States for protected inputs
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    return(
        <>
            <div className={styles.FormBlock}>
                <form action="" className={styles.Form} onSubmit={(e)=>{
                e.preventDefault();
                    }}>
                    <div className={styles.InputCapsule}>
                        <PasswordInput password={password} onChange={setPassword}/>
                        <PasswordInput text="Heslo znovu" password={confirmPassword} onChange={setConfirmPassword}/>
                    </div>
                    <SubmitButton text="Potvrdit"/>
                </form>
            <div className={styles.FormSubtitle}><p>{t("forgot_password.reset_sent")}</p></div>
            <p className={styles.Hint}>{t("forgot_password.go_back")}</p>
            <SubmitButton text={t("buttons.back")} onClick={onBack}/>
        </div>
        </>
    )
};

export default ResetStage;





*/
